import { ComponentMetadataModel, ParameterMetadata, ParameterType, PrimitiveType } from '../../../api/api';

const timestampDisplayFormatOptions = ['Timestamp', 'Relative'].map((value) => ({
	name: value,
	value,
	description: undefined,
}));

function stringParameter(name: string, displayName: string, order: number): ParameterMetadata {
	return {
		name,
		displayName,
		order,
		type: ParameterType.Primitive,
		categories: [],
		isCollection: false,
		expectedType: { type: PrimitiveType.String },
	};
}

function timestampDisplayFormatParameter(name: string, displayName: string, order: number): ParameterMetadata {
	return {
		name,
		displayName,
		order,
		type: ParameterType.Primitive,
		categories: [],
		isCollection: false,
		expectedType: { type: PrimitiveType.String },
		valueOptions: timestampDisplayFormatOptions,
	};
}

export const ListMessageChatItemMetadata: ComponentMetadataModel = {
	name: 'ListMessageChatItemModel',
	displayName: 'List Message Chat Item',
	category: 'Virtual',
	categories: ['Virtual'],
	description: 'The message template used by a List Message Chat component.',
	parameters: [
		stringParameter('ContentField', 'Content Field', 1),
		stringParameter('TimestampField', 'Timestamp Field', 2),
		timestampDisplayFormatParameter('TimestampDisplayFormat', 'Timestamp Display Format', 3),
		stringParameter('ContactNameField', 'Contact Name Field', 4),
		stringParameter('ContactIdField', 'Contact ID Field', 5),
		stringParameter('ContactLink', 'Contact Link', 6),
	],
	iconName: 'Sms',
	isVirtual: true,
};
